import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import reportingtreejson from "../Tempdata/ReportingTreejson";
import { updatereporttabpath } from "../store/report_data";
import TemplateGroup from "./Reports/TemplateGroup";
import Generate from "./Reports/Generate";
import View from "./Reports/View";
import Scheduler from "./Reports/Scheduler";

const components = {
  TemplateGroup: TemplateGroup,
  Generate: Generate,
  View: View,
  Scheduler: Scheduler,
};

function ConfigTab({ componentName }) {
  const ComponentToRender = components[componentName];
  return ComponentToRender ? <ComponentToRender /> : null;
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ borderRadius: "0px" }}
    >
      {value === index && (
        <Box sx={{ p: 0, borderRadius: "0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ReportingMainPage(props) {
  const dispatch = useDispatch();
  const tabpath = useSelector(
    (state) => state.reportdata.selectedreporttabpath,
  );
  const selectedtreepath = useSelector(
    (state) => state.reportdata.reporttreepathselected,
  );
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate,
  );
  const [value, setValue] = React.useState();
  const [mainpath, setMainpath] = useState([]);
  const [pagesize, setPagesize] = useState(270);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (selectedtreepath[0] === "Generation") {
      if (value === 0) {
        setMainpath(["Generate"]);
      } else if (value === 1) {
        setMainpath(["Generated Reports"]);
      }
    } else if (selectedtreepath[0] === "Creation") {
      if (value === 0) {
        setMainpath(["Template Group"]);
      }
    } else if (selectedtreepath[0] === "Scheduler") {
      if (value === 0) {
        setMainpath(["Schedule"]);
      }
    } else {
      setMainpath([]);
    }
  }, [value, selectedtreepath]);

  useEffect(() => {
    setValue(0);
  }, [selectedtreepath]);

  useEffect(() => {
    dispatch(updatereporttabpath(mainpath));
  }, [mainpath]);

  useEffect(() => {
    if (overviewstate) {
      setPagesize(295);
    } else {
      setPagesize(260);
    }
  }, [overviewstate]);

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "var(--SecondaryBackground)",
        borderRadius: "0px 0px 0px 0px",
        marginRight: "0px",
      }}
    >
      <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            width: "auto",
            "& .MuiTabs-indicator": { display: "none" },
            "& .Mui-selected": {
              backgroundColor: "var(--SecondaryBackground)",
              borderRadius: "0px 0px 0px 0px",
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {reportingtreejson.map((item) =>
            selectedtreepath[0] === item.label ? (
              item.child.length === 0 ? (
                <Tab
                  label={item.label}
                  sx={{ minHeight: "30px", height: "30px" }}
                  style={{
                    color: "var(--GreyVariation_2)",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "16.41px",
                    textTransform: "capitalize",
                    flexGrow: 0,
                  }}
                />
              ) : (
                item.child.map((it) => (
                  <Tab
                    label={it.label}
                    sx={{ minHeight: "30px", height: "30px" }}
                    style={{
                      color: "var(--GreyVariation_2)",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "16.41px",
                      textTransform: "capitalize",
                      flexGrow: 0,
                    }}
                  />
                ))
              )
            ) : null,
          )}
        </Tabs>
      </Box>
      <Box
        sx={{
          width: "calc(100%-16px)",
          padding: "8px",
          border: "1px solid var(--HighlightedText_Stroke)",
          height: `calc(100vh - ${pagesize}px - 16px)`,
        }}
        style={{ overflow: "auto" }}
      >
        {reportingtreejson.map((item) =>
          selectedtreepath[0] === item.label ? (
            item.child.length === 0 ? (
              <ConfigTab componentName={item.pagename} />
            ) : (
              item.child.map((it) =>
                tabpath[0] === it.label ? (
                  <ConfigTab componentName={it.pagename} />
                ) : null,
              )
            )
          ) : null,
        )}
      </Box>
    </Box>
  );
}
